import { render, staticRenderFns } from "./ChannelsAndLength.vue?vue&type=template&id=43c55e00&scoped=true&"
import script from "./ChannelsAndLength.vue?vue&type=script&lang=js&"
export * from "./ChannelsAndLength.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsAndLength.vue?vue&type=style&index=0&id=43c55e00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c55e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VChipGroup,VCol,VForm,VRow,VSelect,VTextField})
